import { Fragment } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import GlobalNavigation from "@/patterns/global-nav/src/index";

import { ParentScrollTracking } from "../../../../utils/scroll-tracking";
import {
    JswCollaborateSection,
    AiSection,
    JswDoubleFeatureSection,
    TestimonialSection,
    ClosingBanner,
    BuildAndSupportDoubleFeatureSection,
    IntegrationsSection,
    HeroSection,
    LogoBanner,
    AirCanadaLogo,
    CanvaLogo,
    DominosLogo,
    FordLogo,
    NasaLogo,
    VisaLogo
} from "../sections/ATLAS-55799";
import { Footer } from "../sections/ATLAS-55799/footer";
import JiraSoftwareNav from "../sections/productionized/software-jira-navbar";
import JiraSoftwareNavV2 from "../sections/productionized/software-jira-navbar-v2";
import { ToastSection } from "../sections/toast-section";

export const Atlas55799ProductTourOverview = ({
    showNewNav
}: {
    showNewNav?: boolean;
}) => {
    const intl = useIntl();

    const sectionContainerStyles = css({
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
    });

    const closingBannerContent = {
        text: intl.formatMessage({
            id: "jira-product-tour.closing-banner.header-text",
            defaultMessage:
                "No matter what you're trying to dream up, Jira helps you get it done"
        }),
        imgUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/closing-banner-graphic.webp",
        altText: "hand image",
        starImageUrl:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/artboard-stars.webp",
        starsAltText: "star image",
        buttonText: intl.formatMessage({
            id: "jira-product-tour.closing-banner.button-text",
            defaultMessage: "Get Jira free"
        }),
        ctaButtonUrl: "/try/cloud/signup?bundle=jira-software"
    };

    const svgArray = [
        NasaLogo,
        AirCanadaLogo,
        VisaLogo,
        CanvaLogo,
        DominosLogo,
        FordLogo
    ];

    return (
        <div>
            {showNewNav ? (
                <JiraSoftwareNavV2 />
            ) : (
                <Fragment>
                    <div>
                        <GlobalNavigation
                            showTryNow={false}
                            color={"#f4f5f7"}
                            productKey="jiraSoftware"
                        />
                    </div>
                    <JiraSoftwareNav />
                </Fragment>
            )}
            <div css={sectionContainerStyles}>
                <ParentScrollTracking
                    scrollTrackingEnabled={true}
                    pageId="Jira"
                >
                    <HeroSection />
                    <LogoBanner svgArray={svgArray} />
                    <JswCollaborateSection />
                    <AiSection />
                    <BuildAndSupportDoubleFeatureSection />
                    <JswDoubleFeatureSection />
                    <IntegrationsSection />
                    <TestimonialSection />
                    <ClosingBanner {...closingBannerContent} />
                    <ToastSection />
                    <Footer />
                </ParentScrollTracking>
            </div>
        </div>
    );
};
